import React from "react";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import DashboardLandingPage from "../../components/b2bCandidate/dashboard/DashboardLandingPage";
import { ROLES } from "../../constants/UserRoles";

function B2BCandidateDashboard() {
  return (
    <div className="hirePlusPlusPageContent">
      <Sidebar activePage="dashboard" userRole={ROLES.b2b_candidate} />
      <div className="w-full hireplusplusRightContent">
        <Topbar
          activePage="dashboard"
          userRole={ROLES.b2b_candidate}
          noNavigate={true}
          driverFlag="dashboard"
          newTitle="Dashboard"
        />
        <DashboardLandingPage />
      </div>
    </div>
  );
}

export default B2BCandidateDashboard;
